import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
})
export class GalleryComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  groupedServices: any = [];
  constructor() {}
  displayCustom: boolean = false;

  activeIndex: number = 0;
  columns: any = [];

  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5,
    },
    {
      breakpoint: '1024px',
      numVisible: 3,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  ngOnInit(): void {
    this.updateGroupedServices();

    this.splitIntoColumn(3);
  }

  splitIntoColumn(numOfColumns: number) {
    if (this.data?.details?.services) {
      const images = this.data.details.services;
      this.columns = Array.from({ length: numOfColumns }, () => []);

      images.forEach((item: any, index: number) => {
        if (typeof item === 'object' && item.image) {
          this.columns[index % numOfColumns].push({ ...item, index: index });
        } else if (typeof item === 'string') {
          // إذا كانت العناصر نصوصًا فقط
          this.columns[index % numOfColumns].push(item);
        }
      });
    }
  }
  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
  groupArray<T>(arr: T[], chunkSize: number): T[][] {
    const groups: T[][] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      groups.push(arr.slice(i, i + chunkSize));
    }
    return groups;
  }

  updateGroupedServices() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 767) {
      this.groupedServices = this.groupArray(this.data.details.services, 8);
    } else if (screenWidth >= 576 && screenWidth < 767) {
      this.groupedServices = this.groupArray(this.data.details.services, 6);
    } else if (screenWidth < 576) {
      this.groupedServices = this.groupArray(this.data.details.services, 4);
    }
  }
  openLink(link: string) {
    if (link) {
      window.open(link, '_blank');
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateGroupedServices();
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      this.splitIntoColumn(2);
    } else {
      this.splitIntoColumn(3);
    }
  }
}
